import { createContext, use } from 'react';
import type { FormNameKey } from '../@types/common-data-types';

type AppPermissions = {
  canCreateBackendRecordsPermission: boolean;
  addNodePermission: Record<FormNameKey, boolean>;
  editNodePermission: Record<FormNameKey, boolean>;
  removeNodePermission: Record<FormNameKey, boolean>;

  resolvePermissionsByNodeType: (type?: string) => {
    addNodePermission: boolean;
    editNodePermission: boolean;
    removeNodePermission: boolean;
  };
};

export const AppPermissionsContext = createContext<AppPermissions | undefined>(undefined);

// context consumer hook
export const useAppPermissionsContext = () => {
  const context = use(AppPermissionsContext);

  if (context === undefined) {
    throw new Error('useAppPermissionsContext must be used within a AppPermissionsProvider');
  }

  return context;
};
